import { RootState } from 'app/store';
import AttributionButton from 'features/attribute-model/attributeButton';
import SearchBar from 'features/search-bar/searchBar';
import {
  applySearchToTableAndGraph,
  clearSearch,
  getSearchTermsById
} from 'features/search-bar/searchBarSlice';
import { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReportsCSVExportButton from './reports-csv-export-button';
import { ReportExport } from './types/report-export';
import AttributionCompareButton from 'features/attribute-compare-model/attributeCompareButton';
import { selectIsAttributionComparisonActive } from 'features/attribute-compare-model/availableAttributionCompareModelsSlice';

const ReportsInteractionBar: FC<{
  componentId: string;
  reportExport: ReportExport;
}> = ({
  componentId,
  reportExport
}: {
  componentId: string;
  reportExport: ReportExport;
}) => {
  const dispatch = useDispatch();

  const { tableValueToSearch } = useSelector((state: RootState) =>
    getSearchTermsById(state, componentId)
  );

  const displayComparisonAttributionModelData = useSelector(
    (state: RootState) => selectIsAttributionComparisonActive(state)
  );

  return (
    <>
      <div className="flex flex-row align-middle justify-between flex-wrap py-3 w-full">
        <SearchBar
          key={componentId}
          searchValue={tableValueToSearch}
          onClickFunction={(searchTerm: string) => {
            dispatch(
              applySearchToTableAndGraph({
                id: componentId,
                valueToSearch: searchTerm
              })
            );
          }}
          onClearFunction={() => {
            dispatch(
              clearSearch({
                id: componentId
              })
            );
          }}
        />
        <div className="mt-3 lg:mt-0 flex items-center justify-between w-full md:w-auto">
          {!displayComparisonAttributionModelData && (
            <div className="md:mr-3">
              <ReportsCSVExportButton reportExport={reportExport} />
            </div>
          )}
          <AttributionButton dropDirection="left" width="w-60" />
          <AttributionCompareButton />
        </div>
      </div>
    </>
  );
};

export default ReportsInteractionBar;
